import React from 'react'
import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import cn from 'classnames'
import { lang } from './lang'
import CardImage from '~pages/CardsPage/components/CardImage'
import { useCards, useGetThreeDSChallengesData, useProducts } from '~api'
import StatusBadge from '~pages/CardsPage/components/StatusBadge'

interface Props {
    setSelectedCard: (selectedCard: GetCard) => void
    selectedCard?: GetCard
    onAddNew: () => void
}

const getType = (card: GetCard) => {
    if (card.card_type === 'VIRTUAL') {
        return <FormattedHTMLMessage {...lang.virtual} />
    }

    if (card.card_type === 'PHYSICAL') {
        return <FormattedHTMLMessage {...lang.physical} />
    }

    return card.card_type
}

function Content({ selectedCard, setSelectedCard, onAddNew }: Props) {
    const { data: chData } = useGetThreeDSChallengesData()
    const { data: cardData } = useCards()
    const { data: products } = useProducts()

    return (
        <div className="flex flex-col overflow-hidden">
            <div className="flex flex-col scrollable overflow-auto">
                {cardData?.cards?.map(card => (
                    <div
                        key={card.id}
                        className={cn(
                            'flex items-center py-3 cursor-pointer',
                            selectedCard?.id === card?.id && 'bg-background-accent-alpha'
                        )}
                        onClick={() => setSelectedCard(card)}
                    >
                        <div className="flex items-center gap-3">
                            <CardImage
                                designId={card?.card_design?.id}
                                className="ml-5 w-[62px] h-[42px] [&>img]:h-full"
                                status={card?.status}
                                showBlurredText={false}
                                blurredImgSize={24}
                            />
                            <div className="flex items-center gap-2">
                                <span className="text-body">·· {card?.masked_number || '****'}</span>
                                <span className="text-subhead text-text-secondary">{getType(card)}</span>
                                {chData?.challenges?.some(ch => ch?.card_id === card?.id) && (
                                    <AppSvg
                                        svgName={newIcons.ic24Info}
                                        size={24}
                                        path="new-icons"
                                        className="text-icon-warning transform-[rotate(180deg)]"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="ml-auto mr-5">
                            <StatusBadge card={card} />
                        </div>
                    </div>
                ))}
            </div>
            {products?.products && products?.products?.length > 0 && (
                <div className="px-5 my-4">
                    <Button
                        dataPointer="add_new"
                        fullWidth
                        prefix={<AppSvg svgName={newIcons.ic24Plus} path="new-icons" size={24} />}
                        size="l"
                        onClick={onAddNew}
                    >
                        <FormattedHTMLMessage {...lang.addNew} />
                    </Button>
                </div>
            )}
        </div>
    )
}

export default Content
